import React from 'react'
import Banner from '../Components/Banner/Banner'
import CoinsTable from '../Components/CoinsTable'

const HomePage = () => {
  return (
    <div>
      <Banner/>
      <CoinsTable/>
    </div>
  )
}

export default HomePage
